import React from 'react';
import Prism from 'prismjs';
import 'prismjs/components/prism-jsx';
import { ConfigContext } from '../config-provider';
import classNames from 'classnames';
// const cssUrl = new URL('/bdesign-default.css', import.meta.url).href;
const PRISM_THEME_CSS_LINK = {
    'b-design': 'https://acd-assets.alicdn.com/acd_work/b-design-doc/v3/bdesign-default.css',
    'prism-default': 'https://cdn.jsdelivr.net/gh/PrismJS/prism@1.27.0/themes/prism.min.css',
    coy: 'https://cdn.jsdelivr.net/gh/PrismJS/prism@1.27.0/themes/prism-coy.min.css',
    dark: 'https://cdn.jsdelivr.net/gh/PrismJS/prism@1.27.0/themes/prism-dark.min.css',
    funky: 'https://cdn.jsdelivr.net/gh/PrismJS/prism@1.27.0/themes/prism-funky.min.css',
    okaidia: 'https://cdn.jsdelivr.net/gh/PrismJS/prism@1.27.0/themes/prism-okaidia.min.css',
    solarizedlight: 'https://cdn.jsdelivr.net/gh/PrismJS/prism@1.27.0/themes/prism-solarizedlight.min.css',
    tomorrow: 'https://cdn.jsdelivr.net/gh/PrismJS/prism@1.27.0/themes/prism-tomorrow.min.css',
    twilight: 'https://cdn.jsdelivr.net/gh/PrismJS/prism@1.27.0/themes/prism-twilight.min.css'
};
export class CodeSnippet extends React.Component {
    static contextType = ConfigContext;
    shadowRef;
    constructor(props) {
        super(props);
        this.shadowRef = React.createRef();
    }
    componentDidMount() {
        this.attachShadow(this.shadowRef?.current);
    }
    componentDidUpdate(prevProps, prevState, snapshot) { }
    getSnapshotBeforeUpdate(prevProps, prevState) {
        this.attachShadow(this.shadowRef?.current);
        const linkRef = this.shadowRef.current.shadowRoot?.querySelector('link');
        if (!linkRef)
            return this.props;
        linkRef.href = PRISM_THEME_CSS_LINK[this.props.theme];
        return this.props;
    }
    attachShadow = (host) => {
        if (!host)
            return;
        if (!this.props.language || !Prism.languages[this.props.language])
            return;
        if (!host.shadowRoot) {
            const wrapper = document.createElement('pre');
            wrapper.className = classNames(host.className, `language-${this.props.language}`);
            const highlight = Prism.highlight(this.props.code, Prism.languages[this.props.language], this.props.language);
            wrapper.innerHTML = highlight;
            const shadowRoot = host.attachShadow({ mode: 'open' });
            shadowRoot.append(wrapper);
            const linkSheet = document.createElement('link');
            linkSheet.type = 'text/css';
            linkSheet.rel = 'stylesheet';
            linkSheet.href = PRISM_THEME_CSS_LINK[this.props.theme || 'bDesign'];
            shadowRoot.append(linkSheet);
        }
        else {
            const pre = host.shadowRoot.querySelector('pre');
            pre.innerHTML = Prism.highlight(this.props.code, Prism.languages[this.props.language], this.props.language);
        }
    };
    render() {
        const prefixCls = this.context.getPrefixCls('code-snippet', this.props.prefix);
        return React.createElement("div", { ref: this.shadowRef, className: classNames(prefixCls), style: { ...this.props.style } });
    }
}
export default CodeSnippet;
